
import { useState, useEffect } from "react";
import PhoneInput from "../ui/phoneInput";
export default function PhoneNumberScreen({ onClose, onContinue, extdetails }) {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  useEffect(() => {
    if (extdetails?.name) setName(extdetails.name);
    if (extdetails?.phone) setPhone(extdetails.phone);
  }, [extdetails]);

  const handleContinue = () => {
    onContinue({
      name: name,
      phone: phone,
    });
  }
  const handleClose = () => {
    onClose({
      name: name,
      phone: phone,
    });
  }
  return (
    <div className="relative h-fit py-3 bg-white flex flex-col">
      {/* Top Back Button */}
      <div className="md:pl-4 pl-2">
        <button
          onClick={handleClose}
          className="md:w-12 w-8 md:h-12 h-8 flex items-center justify-center text-white rounded-xl transition-colors"
        >
          <img
            src="/images/back.png"
            alt="back"
            className="md:w-[50px] md:h-[50px] w-[30px] h-[30px] rounded-[12px]"
          />
        </button>
      </div>

      {/* Content */}
      <div className="flex flex-col items-center px-6 md:mb-16 mb-8 text-center flex-grow">
        <div className="mb-10 md:text-[30px] text-[20px] font-outfit font-semibold text-gray-800 leading-snug">
          We’ll call you when it’s ready. <br /> Please add your name and number to continue.
        </div>

        {/* Name Input */}
        <div className="mt-10 mb-10 md:w-[400px] w-full max-w-sm">
          <input
            type="text"
            value={name}
            maxLength={16}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your Name"
            className="w-full md:text-[30px] text-[20px] px-4 py-3 border-[2px] font-outfit border rounded-xl focus:outline-none"
          />
        </div>
        {/* phone Input */}
        <PhoneInput value={phone} onChange={setPhone} />
      </div>
      {/*Pay Button */}
      <div className="sticky bottom-0 w-full">
        <button
          className="w-full py-4 rounded-[12px] bg-boonsOrange border-[2px] text-white md:text-[40px] text-[20px] font-outfit font-medium disabled:opacity-60" onClick={handleContinue}
          disabled={name.trim().length < 2 || phone.length < 10}
        >
          Continue to pay
        </button>
      </div>
    </div>
  );
}
